/* @todo : delete this file when cms destinations will be in cms sections */

import { COLORS } from 'Components/utils/color/colors.js';

function _mapIntroduction({ name, subTitle, description, href }) {
  return {
    Introduction: {
      content: {
        title: name,
        subTitle,
        description,
      },
      color: COLORS.PRUNE,
      href,
    },
  };
}

function _mapLinkBlocks(zones = []) {
  return zones.map(({ zone = [], name, description, image, href }) => {
    const details = zone.map(subZone => {
      return {
        label: subZone.name,
        href: subZone.href,
      };
    });

    return {
      LinksBlock: {
        block: {
          label: name,
          description,
          image,
          details,
          href,
        },
        color: COLORS.PRUNE,
        fadeEffect: true,
      },
    };
  });
}

export function build(cmsDestination = {}) {
  const sectionDestination = [];
  sectionDestination.push(_mapIntroduction(cmsDestination));
  _mapLinkBlocks(cmsDestination.zone).map(linkBlock => sectionDestination.push(linkBlock));

  return sectionDestination;
}
